import { useCrossfadeStore } from './store.ts'
import { Fader } from './Fader.tsx'

export function Crossfader() {
  const crossfade = useCrossfadeStore(state => state.crossfade)
  const setCrossfade = useCrossfadeStore(state => state.setCrossfade)

  return (
    <div
      className="h-[60px] border-t border-[#444] px-3 flex items-center gap-3 shrink-0"
      style={{ backgroundImage: 'radial-gradient(circle at center, #2b2b2b, #000)' }}
    >
      <span className="text-xs text-[#888] select-none">A</span>
      <div className="flex-1 flex items-center">
        <Fader
          min={0}
          max={1}
          step={0.01}
          faderWidth={6}
          value={crossfade}
          onChange={setCrossfade}
          className="w-full h-[30px]"
          aria-label="Crossfade between A and B"
        />
      </div>
      <span className="text-xs text-[#888] select-none">B</span>
    </div>
  )
}




